import React from "react";
import { Box, Typography, CircularProgress } from "@mui/material";
import { useTranslation } from "react-i18next";
import CalculationWarning from "./CalculationWarning";

/* import { Paper, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Alert } from "@mui/material";
import { useDesignTokens } from "../../context/ThemeContext";

const formatCurrency = (value) => {
    if (value === null || value === undefined || value === "") return "";
    return new Intl.NumberFormat("pt-PT", {
        style: "currency",
        currency: "EUR",
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
    }).format(Number(value));
};

const SectionRows = ({ section }) => {
    const lineItems = section.lineItems || [];

    return (
        <>
            <TableRow sx={{ backgroundColor: "#9e9e9e" }}>
                <TableCell colSpan={4} sx={{ color: "#fff", fontWeight: 700, fontStyle: "italic" }}>
                    {section.section}
                </TableCell>
            </TableRow>

            {lineItems.length === 0 ? (
                <TableRow>
                    <TableCell colSpan={4} sx={{ textAlign: "center", color: "var(--text-secondary)", py: 1.5 }}>
                        Sem itens calculados para esta secção
                    </TableCell>
                </TableRow>
            ) : (
                lineItems.map((item, idx) => (
                    <TableRow key={idx} sx={{ backgroundColor: idx % 2 === 0 ? "transparent" : "rgba(0,0,0,0.02)" }}>
                        <TableCell sx={{ pl: 3 }}>{item.description}</TableCell>
                        <TableCell sx={{ textAlign: "center" }}>{item.quantity}</TableCell>
                        <TableCell sx={{ textAlign: "right" }}>{formatCurrency(item.unitPrice)}</TableCell>
                        <TableCell sx={{ textAlign: "right", fontWeight: 600 }}>{formatCurrency(item.subtotal)}</TableCell>
                    </TableRow>
                ))
            )}

            <TableRow sx={{ backgroundColor: "rgba(0,0,0,0.04)" }}>
                <TableCell colSpan={3} sx={{ textAlign: "right", fontWeight: 700 }}>
                    Subtotal {section.section}
                </TableCell>
                <TableCell sx={{ textAlign: "right", fontWeight: 700 }}>
                    {formatCurrency(section.sectionTotal)}
                </TableCell>
            </TableRow>
        </>
    );
}; */

const BudgetCostSummary = ({ data, loading, error }) => {
    const { t } = useTranslation();

    if (loading) {
        return (
            <Box sx={{ display: "flex", alignItems: "center", justifyContent: "center", flexDirection: "column", gap: 2, py: 6 }}>
                <CircularProgress size={40} sx={{ color: "primary.main" }} />
                <Typography variant="body1" sx={{ color: "var(--text-secondary)", fontWeight: 500 }}>
                    {t("budgetForm.costSummary.calculating")}
                </Typography>
            </Box>
        );
    }

    if (error) {
        return <CalculationWarning error={error} />;
    }

    if (!data) {
        return (
            <Box sx={{ p: 4, textAlign: "center" }}>
                <Typography variant="body1" color="text.secondary">
                    {t("budgetForm.costSummary.noBudget")}
                </Typography>
            </Box>
        );
    }

    /* const sections = [data.towerCost, data.tankCost].filter(Boolean);
    const warnings = sections.flatMap((section) => section.warnings || []);

    return (
        <Box sx={{ mt: 4 }}>
            <Typography
                variant="h5"
                sx={{ mb: 3, fontWeight: 700, color: "var(--text-primary)", textAlign: "center" }}
            >
                Resumo Orçamento
            </Typography>

            <TableContainer component={Paper} variant="outlined" sx={{ borderRadius: 2, overflowX: "auto" }}>
                <Table size="small" sx={{ minWidth: 600 }}>
                    <TableHead>
                        <TableRow sx={{ backgroundColor: tokens.tableHeaderBg }}>
                            <TableCell sx={{ color: tokens.tableHeaderText, fontWeight: 600, minWidth: 320 }}>Descrição</TableCell>
                            <TableCell sx={{ color: tokens.tableHeaderText, fontWeight: 600, width: 90, textAlign: "center" }}>Qtd</TableCell>
                            <TableCell sx={{ color: tokens.tableHeaderText, fontWeight: 600, width: 130, textAlign: "right" }}>Preço Unit.</TableCell>
                            <TableCell sx={{ color: tokens.tableHeaderText, fontWeight: 600, width: 130, textAlign: "right" }}>Subtotal</TableCell>
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        {sections.map((section, idx) => (
                            <SectionRows key={idx} section={section} />
                        ))}

                        <TableRow sx={{ backgroundColor: "#9e9e9e" }}>
                            <TableCell colSpan={3} sx={{ color: "#fff", fontWeight: 700, fontSize: "1.05rem", fontStyle: "italic" }}>
                                Total Global
                            </TableCell>
                            <TableCell sx={{ color: "#fff", fontWeight: 700, fontSize: "1.05rem", textAlign: "right" }}>
                                {formatCurrency(data.totalCost)}
                            </TableCell>
                        </TableRow>
                    </TableBody>
                </Table>
            </TableContainer>

            {warnings.length > 0 && (
                <Alert severity="warning" sx={{ mt: 2 }}>
                    {warnings.map((warning, idx) => (
                        <Typography key={idx} variant="body2">
                            {warning}
                        </Typography>
                    ))}
                </Alert>
            )}
        </Box>
    ); */

    return null;
};

export default BudgetCostSummary;
